import { render } from "./productsView.vue?vue&type=template&id=3be0d218&scoped=true"
import script from "./productsView.vue?vue&type=script&lang=js"
export * from "./productsView.vue?vue&type=script&lang=js"

import "./productsView.vue?vue&type=style&index=0&id=3be0d218&scoped=true&lang=css"
import "./productsView.vue?vue&type=style&index=1&id=3be0d218&scoped=true&lang=css"
import "./productsView.vue?vue&type=style&index=2&id=3be0d218&scoped=true&lang=css"
import "./productsView.vue?vue&type=style&index=3&id=3be0d218&scoped=true&lang=css"
import "./productsView.vue?vue&type=style&index=4&id=3be0d218&scoped=true&lang=css"
import "./productsView.vue?vue&type=style&index=5&id=3be0d218&scoped=true&lang=css"
import "./productsView.vue?vue&type=style&index=6&id=3be0d218&scoped=true&lang=css"
import "./productsView.vue?vue&type=style&index=7&id=3be0d218&scoped=true&lang=css"
import "./productsView.vue?vue&type=style&index=8&id=3be0d218&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be0d218"]])

export default __exports__